/** Deutsch — Kundenportal */
export const de = {
  'layout.portalTitle': 'Anbieterportal ',
  'layout.nav.dashboard': 'Dashboard',
  'layout.nav.bookingTemplates': 'Buchungsvorlagen',
  'layout.nav.contacts': 'Service',
  'layout.nav.enquiry': 'Anfragen',
  'layout.nav.bookings': 'Buchungen',
  'layout.nav.bookingUsers': 'Benutzerzugriffssteuerung',
  'layout.nav.slots': 'Zeitfenster',
  'layout.nav.batchJobs': 'Slot-Generierung',
  'layout.nav.promotions': 'Promotionen',
  'layout.nav.customPush': 'Custom-Push-Benachrichtigungen',
  'layout.nav.chat': 'Chat',
  'layout.nav.faq': 'FAQ',

  'pages.faq.title': 'Häufig gestellte Fragen (FAQ)',
  'pages.faq.subtitle': 'Finden Sie schnelle Antworten auf häufige Fragen zu Services, Buchungen, Zeitfenstern, Werbeaktionen und Kontoeinstellungen.',
  'pages.faq.searchPlaceholder': 'Fragen oder Suchbegriffe eingeben...',
  'pages.faq.categories.all': 'Alle Fragen',
  'pages.faq.categories.account': 'Konto & Einrichtung',
  'pages.faq.categories.services': 'Dienste & Vorlagen',
  'pages.faq.categories.bookings': 'Buchungen & Slots',
  'pages.faq.categories.promotions': 'Aktionen & Rabatte',
  'pages.faq.categories.support': 'Support & Sicherheit',
  'pages.faq.expandAll': 'Alle ausklappen',
  'pages.faq.collapseAll': 'Alle einklappen',
  'pages.faq.searchResultsCount': '{{count}} passende Frage(n) für "{{query}}" gefunden',
  'pages.faq.noResultsTitle': 'Keine passenden Fragen gefunden',
  'pages.faq.noResultsSubtitle': 'Versuchen Sie, Ihre Suche anzupassen oder wählen Sie eine andere Kategorie.',
  'pages.faq.clearFilters': 'Suche & Filter zurücksetzen',
  'pages.faq.needHelpTitle': 'Haben Sie noch Fragen?',
  'pages.faq.needHelpSubtitle': 'Sie finden nicht die passende Antwort? Kontaktieren Sie unser Support-Team direkt.',
  'pages.faq.chatWithUs': 'Mit Support chatten',
  'pages.faq.sendEnquiry': 'Anfrage senden',
  'pages.faq.helpCenter': 'Hilfe-Center',
  'pages.faq.items.q2.question': 'Wie setze ich mein Passwort zurück oder aktualisiere es?',
  'pages.faq.items.q2.answer': 'Klicken Sie oben rechts auf Ihr Profil-Initial, wählen Sie "Passwort ändern", geben Sie Ihr aktuelles und neues Passwort ein und speichern Sie. Sie können auch "Passwort vergessen" auf dem Login-Bildschirm nutzen.',
  'pages.faq.items.q3.question': 'Wie erstelle und veröffentliche ich ein neues Service-Angebot?',
  'pages.faq.items.q3.answer': 'Gehen Sie im Menü auf die Seite Service, klicken Sie auf "+ Service hinzufügen", tragen Sie Kategorie, Stadt, Adresse, Preise, Beschreibung und Bilder ein und speichern Sie.',
  'pages.faq.items.q4.question': 'Was sind Buchungsvorlagen und wie konfiguriere ich sie?',
  'pages.faq.items.q4.answer': 'Buchungsvorlagen definieren benutzerdefinierte Formularfelder und Fragen, die Kunden bei der Buchung ausfüllen müssen. Unter "Buchungsvorlagen" wählen Sie ein Service und fügen Eingabefelder hinzu.',
  'pages.faq.items.q5.question': 'Wie funktionieren Kundenbuchungen und wie verwalte ich sie?',
  'pages.faq.items.q5.answer': 'Bucht ein Kunde Ihren Service, erscheint die Buchung in der Ansicht "Buchungen". Sie können Kundendaten, Status (Ausstehend, Bestätigt, Storniert) einsehen und den Fortschritt aktualisieren.',
  'pages.faq.items.q6.question': 'Wie generiere ich Zeitfenster für meine Services?',
  'pages.faq.items.q6.answer': 'Zeitfenster können Sie einzeln auf der Seite "Zeitfenster" oder automatisiert über "Slot-Generierung" (Batch-Jobs) für mehrere Wochen oder Monate erstellen.',
  'pages.faq.items.q7.question': 'Wie funktionieren Promotion-Rabattcodes?',
  'pages.faq.items.q7.answer': 'Unter "Promotionen" können Sie Rabattcodes mit prozentualen oder festen Beträgen erstellen, Gültigkeitszeiträume und Nutzungslimits festlegen und bestimmten Services zuweisen.',
  'pages.faq.items.q8.question': 'Kann ich eine Promotion deaktivieren oder löschen?',
  'pages.faq.items.q8.answer': 'Ja, Sie können den Status eines Rabattcodes jederzeit aktivieren/deaktivieren oder den Code dauerhaft aus der Übersicht löschen.',
  'pages.faq.items.q9.question': 'Wie chatte ich mit Benutzern oder Kunden?',
  'pages.faq.items.q9.answer': 'Öffnen Sie den "Chat" im Seitenmenü. Dort sehen Sie alle aktiven Unterhaltungen zu Ihren Services. Wählen Sie einen Chat aus, um Nachrichten und Medien in Echtzeit auszutauschen.',
  'pages.faq.items.q10.question': 'Sind meine Anbieterdaten sicher und verschlüsselt?',
  'pages.faq.items.q10.answer': 'Ja, alle sensiblen Datenübertragungen zwischen Portal und Backend sind mit AES/RSA-Verschlüsselung, TLS-Protokollen und sicheren Authentifizierungs-Tokens geschützt.',
  'pages.faq.items.q11.question': 'Welche Anforderungen und Validierungen gelten für das Hochladen von Bildern bei Services und Promotionen?',
  'pages.faq.items.q11.answer': 'Beim Hochladen von Bildern für Servicekontakte (BannerImages, LogoPicture) oder Promotionen:\n\n• Unterstützte Dateiformate: PNG, JPG, JPEG, WEBP\n• Maximale Dateigröße: Bis zu 10 MB pro Bilddatei\n• Erforderliche Abmessungen:\n  - Bildgröße: 355 × 355 px (1:1 quadratisches Seitenverhältnis).\n• Validierungen: Dateien über 10 MB oder nicht unterstützte Formate werden sofort mit einem Hinweis abgelehnt.',

  'layout.nav.chatUnread': '{{count}} ungelesene Nachrichten',
  'pages.chat.title': 'Nachrichten',
  'pages.chat.subtitle': 'Chatten Sie mit Benutzern über Dienstleistungen',
  'pages.chat.search': 'Benutzer durchsuchen...',
  'pages.chat.typeMessage': 'Nachricht schreiben...',
  'pages.chat.noSelect': 'Wählen Sie eine Konversation aus, um zu chatten',
  'pages.chat.typing': 'schreibt...',
  'pages.chat.selectContact': 'Service auswählen',
  'pages.chat.noConversations': 'Keine Benutzer gefunden',
  'pages.chat.allServices': 'Alle Services',
  'layout.notifications.title': 'Benachrichtigungen',
  'layout.notifications.markAllRead': 'Alle als gelesen markieren',
  'layout.notifications.history': 'Benachrichtigungsverlauf',
  'layout.notifications.viewAll': 'Alle anzeigen',
  'layout.notifications.allTitle': 'Alle Benachrichtigungen',
  'layout.notifications.filterLabel': 'Kategorie',
  'layout.notifications.filterAll': 'Alle Kategorien',
  'layout.notifications.filterAllNotifications': 'Alle Benachrichtigungen',
  'layout.notifications.pageSubtitle': 'Zeigen und verwalten Sie Ihre letzten Benachrichtigungen.',
  'layout.notifications.loading': 'Benachrichtigungen werden geladen…',
  'layout.notifications.table.type': 'Typ',
  'layout.notifications.table.title': 'Titel',
  'layout.notifications.table.message': 'Nachricht',
  'layout.notifications.table.received': 'Empfangen',
  'layout.notifications.table.status': 'Status',
  'layout.notifications.table.actions': 'Aktionen',
  'layout.notifications.statusRead': 'Gelesen',
  'layout.notifications.statusUnread': 'Ungelesen',
  'layout.notifications.markRead': 'Als gelesen markieren',
  'layout.notifications.openLink': 'Link öffnen',
  'layout.notifications.filterPromotion': 'Aktion / Promotion',
  'layout.notifications.filterEvents': 'Veranstaltungen',
  'layout.notifications.filterContact': 'Kontakt',
  'layout.notifications.filterUser': 'Benutzer',
  'layout.notifications.filterSupport': 'Kundensupport',
  'layout.notifications.filterBooking': 'Buchung',
  'layout.notifications.filterEnquiry': 'Anfrage',
  'layout.notifications.empty': 'Noch keine Benachrichtigungen',
  'layout.notifications.loadError': 'Benachrichtigungen konnten nicht geladen werden',
  'layout.notifications.close': 'Schließen',
  'layout.notifications.back': 'Zurück',
  'layout.page.back': 'Zurück',
  'layout.notifications.marking': 'Wird aktualisiert…',
  'layout.profile.tooltip': 'Mein Profil',
  'layout.profile.title': 'Profil',
  'layout.profile.name': 'Name',
  'layout.profile.email': 'E-Mail',
  'layout.profile.role': 'Rolle',
  'layout.profile.loading': 'Wird geladen…',
  'layout.profile.changeName': 'Namen ändern',
  'layout.profile.changePassword': 'Passwort ändern',
  'layout.profile.language': 'Sprache',
  'layout.profile.languageEn': 'Englisch',
  'layout.profile.languageDe': 'Deutsch',
  'layout.profile.logout': 'Abmelden',
  'layout.dialog.changeNameTitle': 'Anzeigenamen ändern',
  'layout.dialog.changeNameSubtitle': 'So wird Ihr Name im Portal angezeigt.',
  'layout.dialog.changePasswordTitle': 'Passwort ändern',
  'layout.dialog.changePasswordSubtitle': 'Aktuelles Passwort, dann neues Passwort zweimal eingeben.',
  'layout.dialog.passwordNewSection': 'Neues Passwort',
  'layout.dialog.displayName': 'Anzeigename',
  'layout.dialog.firstName': 'Vorname',
  'layout.dialog.lastName': 'Nachname',
  'layout.dialog.businessName': 'Firmenname',
  'layout.dialog.currentPassword': 'Aktuelles Passwort',
  'layout.dialog.newPassword': 'Neues Passwort',
  'layout.dialog.confirmPassword': 'Neues Passwort bestätigen',
  'layout.dialog.cancel': 'Abbrechen',
  'layout.dialog.save': 'Speichern',
  'layout.dialog.updatePassword': 'Passwort aktualisieren',
  'layout.toast.nameUpdated': 'Name wurde erfolgreich aktualisiert.',
  'layout.toast.passwordUpdated': 'Passwort wurde erfolgreich aktualisiert.',
  'layout.toast.error': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'layout.toast.passwordMismatch': 'Neues Passwort und Bestätigung stimmen nicht überein.',
  'layout.nav.helpCenter': 'Hilfe-Center',
  'layout.dialog.helpCenterTitle': 'Hilfe-Center',
  'layout.dialog.helpCenterSubtitle': 'Benötigen Sie Hilfe? Senden Sie uns eine Nachricht und wir melden uns bei Ihnen.',
  'layout.dialog.helpCenterMessage': 'Nachricht',
  'layout.toast.helpCenterSuccess': 'Ihre Nachricht wurde erfolgreich gesendet.',


  'pages.templates.title': 'Buchungsvorlagen',

  'pages.dashboard.title': 'Dashboard',
  'pages.dashboard.subtitle': 'Übersicht und Analysen Ihres Kundenportals',
  'pages.dashboard.card.totalBooking': 'Buchungen gesamt',
  'pages.dashboard.card.todayBooking': 'Buchungen heute',
  'pages.dashboard.card.completedBookings': 'Abgeschlossen',
  'pages.dashboard.card.todaySlots': 'Zeitfenster heute',
  'pages.dashboard.card.change1': '+12% zum Vormonat',
  'pages.dashboard.card.change2': '+8% zum Vortag',
  'pages.dashboard.card.change3': '+15% Tagesdurchschnitt',
  'pages.dashboard.legend.bookings': 'Buchungen',
  'pages.dashboard.legend.slots': 'Zeitfenster',
  'pages.dashboard.chart.bookingsVsSlots': 'Buchungen vs. Zeitfenster',
  'pages.dashboard.chart.overallInfo': 'Gesamtübersicht',
  'pages.dashboard.chart.customersOverview': 'Kundenübersicht',
  'pages.dashboard.period': 'Zeitraum',
  'pages.dashboard.period.thisWeek': 'Diese Woche',
  'pages.dashboard.period.thisMonth': 'Dieser Monat',
  'pages.dashboard.period.thisYear': 'Dieses Jahr',
  'pages.dashboard.period.last3Months': 'Letzte 3 Monate',
  'pages.dashboard.period.last6Months': 'Letzte 6 Monate',
  'pages.dashboard.period.lastYear': 'Letztes Jahr',
  'pages.dashboard.pie.firstTime': 'Erstbesuch',
  'pages.dashboard.pie.return': 'Wiederkehrend',
  'pages.dashboard.pie.new': 'Neu',
  'pages.dashboard.summary.completed': 'Abgeschlossene Buchungen',
  'pages.dashboard.summary.cancelled': 'Stornierte Buchungen',
  'pages.dashboard.summary.totalSlots': 'Zeitfenster gesamt',
  'pages.dashboard.today.title': 'Heutige Buchungen',
  'pages.dashboard.today.colTime': 'Zeit',
  'pages.dashboard.today.colMeetingType': 'Besprechungsart',
  'pages.dashboard.today.colTitle': 'Titel',
  'pages.dashboard.today.colContact': 'Kontaktname',
  'pages.dashboard.today.colUserName': 'Benutzername',
  'pages.dashboard.today.colEmail': 'E-Mail',
  'pages.dashboard.today.colStatus': 'Status',
  'pages.dashboard.today.colActions': 'Aktionen',
  'pages.dashboard.today.empty': 'Keine Buchungen für heute',

  'pages.dashboard.views.title': 'Aufruf- und Interaktionsanalysen',
  'pages.dashboard.views.subtitle': 'Aufrufe Ihrer Services und Aktionen im Zeitverlauf nachverfolgen',
  'pages.dashboard.views.module': 'Modul',
  'pages.dashboard.views.contact': 'Kontakte / Services',
  'pages.dashboard.views.promotion': 'Aktionen',
  'pages.dashboard.views.timeFilter': 'Zeitraum',
  'pages.dashboard.views.currentWeek': 'Aktuelle Woche',
  'pages.dashboard.views.byMonth': 'Nach Monat',
  'pages.dashboard.views.fullYear': 'Ganzes Jahr',
  'pages.dashboard.views.year': 'Jahr',
  'pages.dashboard.views.month': 'Monat',
  'pages.dashboard.views.totalViews': 'Aufrufe gesamt',
  'pages.dashboard.views.contactViews': 'Kontakt-Aufrufe',
  'pages.dashboard.views.promotionViews': 'Aktions-Aufrufe',
  'pages.dashboard.views.dailyAverage': 'Tagesdurchschnitt',
  'pages.dashboard.views.peakViews': 'Spitzenaufrufe / Tag',
  'pages.dashboard.views.topItems': 'Meistaufgerufene Einträge',
  'pages.dashboard.views.noTopItems': 'Keine Einträge für diesen Zeitraum',
  'pages.dashboard.views.noData': 'Keine Aufrufdaten für diesen Zeitraum verfügbar',
  'pages.dashboard.views.viewsCount': '{{count}} Aufrufe',
  'pages.dashboard.views.chartArea': 'Fläche',
  'pages.dashboard.views.chartBar': 'Balken',

  'pages.bookings.title': 'Benutzer-Buchungsverwaltung',
  'pages.bookings.appointments': 'Termine',
  'pages.bookings.subtitle': 'Alle aus Ihren Zeitfenstern erstellten Buchungen verfolgen und verwalten',
  'pages.bookings.providerUnavailable': 'Anbieter nicht verfügbar',
  'pages.bookings.transfer': 'Buchungen übertragen',
  'pages.bookings.refresh': 'Aktualisieren',
  'pages.bookings.add': 'Buchung hinzufügen',
  'pages.bookings.filter.status': 'Status',
  'pages.bookings.filter.all': 'Alle',
  'pages.bookings.filter.search': 'Suche nach Titel, Kunde oder Code',
  'pages.bookings.filter.searchTitleCustomer': 'Suche nach Titel, Kunde & Code',
  'pages.bookings.filter.searchTitleCustomerPlaceholder': 'Titel, Kundenname oder Bestätigungscode',
  'pages.bookings.searchPlaceholder': 'Suche nach Titel, Kunde oder Code …',
  'pages.bookings.filter.bookingStatus': 'Genehmigungsstatus',
  'pages.bookings.filter.allStatuses': 'Alle Status',
  'pages.bookings.filter.contact': 'Service',
  'pages.bookings.filter.contactTitle': 'Service-Titel',
  'pages.bookings.filter.template': 'Vorlage',
  'pages.bookings.filter.startDate': 'Startdatum',
  'pages.bookings.filter.endDate': 'Enddatum',
  'pages.bookings.filter.slotDate': 'Termin (Datum)',
  'pages.bookings.filter.slotDateTitle': 'Datum auswählen',
  'pages.bookings.clearSlotDate': 'Datum löschen',
  'pages.bookings.meetingType.online': 'Online',
  'pages.bookings.meetingType.offline': 'Offline',
  'pages.bookings.filter.allContacts': 'Alle Services',
  'pages.bookings.filter.allTemplates': 'Alle Vorlagen',
  'pages.bookings.clearFilters': 'Zurücksetzen',
  'pages.bookings.dateUnknown': 'Kein Datum',
  'pages.bookings.table.time': 'Zeit',
  'pages.bookings.table.bookingDate': 'Buchungsdatum',
  'pages.bookings.table.slotDate': 'Termin',
  'pages.bookings.table.title': 'Titel',
  'pages.bookings.table.customerName': 'Kundenname',
  'pages.bookings.table.userName': 'Benutzername',
  'pages.bookings.table.meetingType': 'Besprechungsart',
  'pages.bookings.table.joinOnlineMeeting': 'An Online-Meeting teilnehmen',
  'pages.bookings.table.customerNumber': 'Kundenummer',
  'pages.bookings.table.contact': 'Service',
  'pages.bookings.table.template': 'Vorlage',
  'pages.bookings.table.duration': 'Dauer',
  'pages.bookings.table.location': 'Ort',
  'pages.bookings.table.price': 'Preis',
  'pages.bookings.table.type': 'Typ',
  'pages.bookings.table.notes': 'Notizen',
  'pages.bookings.table.status': 'Status',
  'pages.bookings.table.actions': 'Aktionen',
  'pages.bookings.pagination.rowsPerPage': 'Zeilen pro Seite',
  'pages.bookings.pagination.displayedRows': '{{from}}–{{to}} von {{count}}',
  'pages.bookings.pagination.unknownTotal': '{{from}}–{{to}} von vielen',
  'pages.bookings.loading': 'Buchungen werden geladen…',
  'pages.bookings.empty': 'Keine Buchungen gefunden',
  'pages.bookings.emptyHint': 'Passen Sie die Filter an oder legen Sie eine neue Buchung an.',
  'pages.bookings.stats.total': 'Buchungen gesamt',
  'pages.bookings.stats.pending': 'Ausstehend',
  'pages.bookings.stats.confirmed': 'Bestätigt',
  'pages.bookings.stats.completed': 'Abgeschlossen',
  'pages.bookings.stats.cancelled': 'Storniert',
  'pages.bookings.dialog.cancelTitle': 'Buchung stornieren - Anbieter nicht verfügbar',
  'pages.bookings.dialog.cancelSubtitle': 'Stornieren Sie eine bestimmte Buchung unter Angabe eines Grundes (z. B. Anbieter nicht verfügbar).',
  'pages.bookings.dialog.selectBooking': 'Buchung auswählen',
  'pages.bookings.dialog.noActionableBookings': 'Es sind keine ausstehenden oder bestätigten Buchungen zur Auswahl verfügbar.',
  'pages.bookings.dialog.cancelReason': 'Stornierungsgrund',
  'pages.bookings.dialog.cancelReasonPlaceholder': 'z. B. Anbieter ist krank, Notfall usw.',
  'pages.bookings.dialog.cancelButton': 'Buchung stornieren',
  'pages.bookings.dialog.cancelErrorBooking': 'Bitte eine Buchung auswählen.',
  'pages.bookings.dialog.cancelErrorReason': 'Bitte einen Stornierungsgrund eingeben.',
  'pages.bookings.dialog.updateStatusTitle': 'Status aktualisieren',
  'pages.bookings.dialog.statusLabel': 'Status',
  'pages.bookings.dialog.notesLabel': 'Notizen',
  'pages.bookings.dialog.notifyCustomer': 'Kunden benachrichtigen',
  'pages.bookings.dialog.updateStatusButton': 'Status aktualisieren',
  'pages.bookings.dialog.transferTitle': 'Buchung übertragen',
  'pages.bookings.dialog.transferSubtitle': 'Übertragen Sie eine Buchung auf einen anderen Anbieter und ein anderes Zeitfenster.',
  'pages.bookings.dialog.selectBookingFull': 'Buchung auswählen (Kundenname - Titel)',
  'pages.bookings.dialog.toProvider': 'An Anbieter',
  'pages.bookings.dialog.toSlot': 'Auf Zeitfenster',
  'pages.bookings.dialog.transferReason': 'Übertragungsgrund',
  'pages.bookings.dialog.transferReasonPlaceholder': 'z. B. Zeitplanänderung, Notfallvertretung',
  'pages.bookings.dialog.transferButton': 'Buchung übertragen',
  'pages.bookings.dialog.transferErrorBooking': 'Bitte eine Buchung auswählen.',
  'pages.bookings.dialog.transferErrorProvider': 'Bitte einen Anbieter auswählen.',
  'pages.bookings.dialog.transferErrorSlot': 'Bitte ein Zeitfenster auswählen.',
  'pages.bookings.dialog.transferErrorReason': 'Bitte einen Übertragungsgrund eingeben.',
  'pages.bookings.dialog.schedule': 'Zeitplan',
  'pages.bookings.dialog.confirmationCode': 'Bestätigungscode',
  'pages.bookings.dialog.created': 'Buchung erstellt',
  'pages.bookings.dialog.appointmentDate': 'Termindatum',
  'pages.bookings.dialog.startTime': 'Startzeit',
  'pages.bookings.dialog.endTime': 'Endzeit',
  'pages.bookings.dialog.noDetails': 'Keine Buchungsdetails verfügbar.',
  'pages.bookings.dialog.sendReminder': 'Erinnerung senden',
  'pages.bookings.dialog.sendReminderTo': 'Erinnerung an {{title}} senden',
  'pages.bookings.dialog.reminderType': 'Erinnerungsart',
  'pages.bookings.dialog.customMessage': 'Benutzerdefinierte Nachricht (optional)',
  'pages.bookings.dialog.customMessagePlaceholder': 'Geben Sie eine benutzerdefinierte Nachricht für die Erinnerung ein...',
  'pages.bookings.dialog.remindCustomerSubtitle': 'Senden Sie eine manuelle Benachrichtigung per E-Mail oder SMS an den Benutzer.',
  'pages.bookings.dialog.noSlots': 'Keine Zeitfenster',
  'pages.bookings.toast.created': 'Buchung erfolgreich erstellt',
  'pages.bookings.toast.updated': 'Buchung erfolgreich aktualisiert',

  'pages.userBookingBlocks.title': 'Benutzerzugriffssteuerung',
  'pages.userBookingBlocks.subtitle': 'Steuern Sie den Zugriff auf Benutzerkonten, indem Sie Benutzer sperren oder entsperren und Buchungsdetails überprüfen.',
  'pages.userBookingBlocks.refresh': 'Aktualisieren',
  'pages.userBookingBlocks.table.displayName': 'Anzeigename',
  'pages.userBookingBlocks.table.email': 'E-Mail',
  'pages.userBookingBlocks.table.totalBookings': 'Buchungen gesamt',
  'pages.userBookingBlocks.table.bookingStatus': 'Nutzer blockiert',
  'pages.userBookingBlocks.table.reason': 'Grund',
  'pages.userBookingBlocks.table.actions': 'Aktionen',
  'pages.userBookingBlocks.viewDetails': 'Details ansehen',
  'pages.userBookingBlocks.on': 'An',
  'pages.userBookingBlocks.off': 'Aus',
  'pages.userBookingBlocks.loading': 'Nutzer werden geladen…',
  'pages.userBookingBlocks.empty': 'Keine Nutzer gefunden',
  'pages.userBookingBlocks.detailsTitle': 'Buchungsdetails des Nutzers',
  'pages.userBookingBlocks.bookingsListTitle': 'Buchungen',
  'pages.userBookingBlocks.noBookings': 'Keine Buchungen für diesen Nutzer gefunden',
  'pages.userBookingBlocks.details.bookingTitle': 'Titel',
  'pages.userBookingBlocks.details.bookingStatus': 'Status',
  'pages.userBookingBlocks.details.bookingDate': 'Termin (Datum)',
  'pages.userBookingBlocks.details.slotTime': 'Terminzeit',
  'pages.userBookingBlocks.details.contactTitle': 'Kontakttitel',
  'pages.userBookingBlocks.details.customerName': 'Kunde',
  'pages.userBookingBlocks.details.customerEmail': 'E-Mail Kunde',
  'pages.userBookingBlocks.details.customerPhone': 'Telefon Kunde',
  'pages.userBookingBlocks.details.serviceAddress': 'Service-Adresse',
  'pages.userBookingBlocks.details.bookingsCount': '{{total}} Buchungen',
  'pages.userBookingBlocks.blockDialog.title': 'Nutzer für Buchungen sperren',
  'pages.userBookingBlocks.blockDialog.subtitle': 'Zukünftige Buchungen bei Ihnen werden storniert. Bitte kurz den Grund angeben.',
  'pages.userBookingBlocks.blockDialog.reason': 'Grund',
  'pages.userBookingBlocks.blockDialog.reasonPlaceholder': 'z. B. wiederholtes Nichterscheinen',
  'pages.userBookingBlocks.blockDialog.confirm': 'Nutzer sperren',
  'pages.userBookingBlocks.blockDialog.reasonRequired': 'Grund ist erforderlich',
  'pages.userBookingBlocks.toast.loadError': 'Nutzer konnten nicht geladen werden',
  'pages.userBookingBlocks.toast.toggleError': 'Buchungszugriff konnte nicht aktualisiert werden',
  'pages.userBookingBlocks.toast.detailsError': 'Nutzerdetails konnten nicht geladen werden',
  'pages.userBookingBlocks.toast.blocked': 'Buchungszugriff wurde deaktiviert',
  'pages.userBookingBlocks.toast.unblocked': 'Buchungszugriff wurde aktiviert',
  'pages.userBookingBlocks.reportUser': 'Nutzer melden',
  'pages.userBookingBlocks.reportDialog.title': 'Nutzer melden',
  'pages.userBookingBlocks.reportDialog.subtitle': 'Wählen Sie einen Grund aus und geben Sie eine detaillierte Beschreibung ein, um diesen Nutzer zu melden.',
  'pages.userBookingBlocks.reportDialog.reasonLabel': 'Grund für die Meldung',
  'pages.userBookingBlocks.reportDialog.selectReasonPlaceholder': 'Grund auswählen...',
  'pages.userBookingBlocks.reportDialog.descriptionLabel': 'Beschreibung',
  'pages.userBookingBlocks.reportDialog.descriptionPlaceholder': 'Detaillierte Beschreibung für die Meldung schreiben...',
  'pages.userBookingBlocks.reportDialog.confirm': 'Meldung absenden',
  'pages.userBookingBlocks.reportDialog.reasonRequired': 'Bitte wählen Sie einen Grund für die Meldung aus',
  'pages.userBookingBlocks.toast.reported': 'Nutzermeldung erfolgreich eingereicht',
  'pages.userBookingBlocks.toast.reportError': 'Nutzermeldung konnte nicht eingereicht werden',
  'pages.userBookingBlocks.reportReason.noShow': 'Nichterscheinen / Nicht erschienen',
  'pages.userBookingBlocks.reportReason.abusive': 'Beleidigendes oder anstößiges Verhalten',
  'pages.userBookingBlocks.reportReason.harassment': 'Belästigung oder Fehlverhalten',
  'pages.userBookingBlocks.reportReason.spam': 'Spam oder gefälschte Buchung',
  'pages.userBookingBlocks.reportReason.misuse': 'Missbrauch des Dienstes',
  'pages.userBookingBlocks.reportReason.fraud': 'Betrügerische Aktivität',
  'pages.userBookingBlocks.reportReason.other': 'Sonstiger Grund',

  'pages.slots.title': 'Zeitfenster-Verwaltung',
  'pages.slots.subtitle': 'Planen und koordinieren Sie Ihre Verfügbarkeit und Buchungen',
  'pages.slots.refresh': 'Aktualisieren',
  'pages.contacts.title': 'Serviceverwaltung',
  'pages.contacts.subtitle': 'Verwalten und organisieren Sie Ihre Services und Anbieter-Einträge',
  'pages.contacts.quickLinks': 'Schnellzugriff',
  'pages.contacts.quickLinksPlaceholder': 'Aktion wählen',
  'pages.contacts.goToNotifications': 'Alle Benachrichtigungen',
  'pages.bookingTemplates.pageTitle': 'Buchungsvorlagen',
  'pages.bookingTemplates.subtitle': 'Konfigurieren und verwalten Sie Ihr Buchungserlebnis',
  'pages.batchJobs.title': 'Slot-Generierung',
  'pages.batchJobs.subtitle': 'Automatische Zeitfenster-Erstellung konfigurieren und geplante Aufträge verwalten',
  'pages.batchJobs.refresh': 'Aktualisieren',
  'pages.batchJobs.configureAutoSlots': 'Auto-Zeitfenster konfigurieren',
  'pages.batchJobs.stats.totalJobs': 'Aufträge gesamt',
  'pages.batchJobs.stats.enabled': 'Aktiv',
  'pages.batchJobs.stats.running': 'Läuft',
  'pages.batchJobs.stats.slotsGenerated': 'Erstellte Zeitfenster',
  'pages.batchJobs.loading': 'Stapelaufträge werden geladen…',
  'pages.batchJobs.empty.title': 'Noch keine Stapelaufträge',
  'pages.batchJobs.empty.hint': 'Nutzen Sie „Auto-Zeitfenster konfigurieren“, um einen automatischen Erstellungsauftrag für einen Kontakt anzulegen.',
  'pages.batchJobs.table.name': 'Name',
  'pages.batchJobs.table.slotGeneration': 'Zeitfenster-Erstellung',
  'pages.batchJobs.table.schedule': 'Zeitplan',
  'pages.batchJobs.table.status': 'Status',
  'pages.batchJobs.table.enabled': 'Aktiv',
  'pages.batchJobs.table.lastRun': 'Letzter Lauf',
  'pages.batchJobs.table.nextRun': 'Nächster Lauf',
  'pages.batchJobs.table.slotsGenerated': 'Erstellte Zeitfenster',
  'pages.batchJobs.table.actions': 'Aktionen',
  'pages.batchJobs.tooltip.run': 'Jetzt ausführen',
  'pages.batchJobs.tooltip.edit': 'Konfiguration bearbeiten',
  'pages.batchJobs.dialog.editTitle': 'Auto-Zeitfenster-Konfiguration bearbeiten',
  'pages.batchJobs.dialog.createTitle': 'Automatische Zeitfenster-Erstellung konfigurieren',
  'pages.batchJobs.form.contact': 'Kontakt',
  'pages.batchJobs.form.selectContact': 'Kontakt wählen',
  'pages.batchJobs.form.autoGenEnabled': 'Automatische Erstellung aktiviert',
  'pages.batchJobs.form.scheduleCron': 'Zeitplan (Cron)',
  'pages.batchJobs.form.scheduleHelp': 'z. B. 0 2 * * * = täglich um 2:00 Uhr',
  'pages.batchJobs.form.daysInAdvance': 'Tage im Voraus',
  'pages.batchJobs.form.defaultTemplate': 'Standardvorlage',
  'pages.batchJobs.form.selectTemplate': 'Vorlage wählen',
  'pages.batchJobs.form.autoConfirm': 'Erstellte Zeitfenster automatisch bestätigen',
  'pages.batchJobs.form.notifyOnGen': 'Bei Erstellung benachrichtigen',
  'pages.batchJobs.form.notificationEmail': 'Benachrichtigungs-E-Mail',
  'pages.batchJobs.form.emailPlaceholder': 'anbieter@beispiel.de',
  'pages.batchJobs.err.contactRequired': 'Kontakt ist erforderlich',
  'pages.batchJobs.err.scheduleRequired': 'Zeitplan ist erforderlich, wenn die automatische Erstellung aktiv ist',
  'pages.batchJobs.err.daysRange': 'Tage im Voraus müssen zwischen 1 und 365 liegen',
  'pages.batchJobs.err.templateRequired': 'Standardvorlage ist erforderlich',
  'pages.batchJobs.err.emailRequired': 'Benachrichtigungs-E-Mail ist erforderlich',
  'pages.batchJobs.err.emailInvalid': 'Bitte eine gültige E-Mail-Adresse eingeben',
  'pages.batchJobs.toast.loadFailed': 'Stapelaufträge konnten nicht geladen werden',
  'pages.batchJobs.toast.saveOk': 'Konfiguration gespeichert',
  'pages.batchJobs.toast.saveFail': 'Speichern fehlgeschlagen',
  'pages.batchJobs.toast.saveErr': 'Konfiguration konnte nicht gespeichert werden',
  'pages.batchJobs.toast.runOk': 'Auftrag wurde gestartet',
  'pages.batchJobs.toast.runFail': 'Ausführung fehlgeschlagen',
  'pages.batchJobs.toast.runErr': 'Auftrag konnte nicht ausgeführt werden',
  'pages.batchJobs.cron.daily2am': 'Täglich um 2:00 Uhr',
  'pages.batchJobs.cron.dailyMidnight': 'Täglich um Mitternacht',
  'pages.batchJobs.cron.every6h': 'Alle 6 Stunden',
  'pages.batchJobs.cron.weeklySun': 'Wöchentlich (Sonntag 3:00 Uhr)',
  'pages.batchJobs.cron.weekdays': 'Werktags um 2:00 Uhr',
  'pages.enquiry.title': 'Anfragen',
  'pages.enquiry.subtitle': 'Kundenanfragen einsehen und eingehende Nachrichten verwalten',
  'pages.enquiry.filter.contact': 'Kontakt',
  'pages.enquiry.filter.allContacts': 'Alle Kontakte',
  'pages.enquiry.filter.status': 'Status',
  'pages.enquiry.filter.allStatuses': 'Alle Status',
  'pages.enquiry.filter.label': 'Filter',
  'pages.enquiry.filter.all': 'Alle',
  'pages.enquiry.filter.new': 'Neu',
  'pages.enquiry.filter.replied': 'Beantwortet',
  'pages.enquiry.filter.search': 'Anfragen durchsuchen...',
  'pages.enquiry.table.userName': 'Benutzername',
  'pages.enquiry.table.email': 'E-Mail',
  'pages.enquiry.table.phone': 'Telefon',
  'pages.enquiry.table.contact': 'Kontakt',
  'pages.enquiry.table.date': 'Datum',
  'pages.enquiry.table.status': 'Status',
  'pages.enquiry.table.message': 'Nachricht',
  'pages.enquiry.table.actions': 'Aktionen',
  'pages.enquiry.status.pending': 'Ausstehend',
  'pages.enquiry.status.inProgress': 'In Bearbeitung',
  'pages.enquiry.status.completed': 'Abgeschlossen',
  'pages.enquiry.status.cancelled': 'Storniert',
  'pages.enquiry.statusUpdateSuccess': 'Anfragestatus erfolgreich aktualisiert',
  'pages.enquiry.statusUpdateError': 'Anfragestatus konnte nicht aktualisiert werden',
  'pages.enquiry.details.title': 'Anfragedetails',
  'pages.enquiry.details.sender': 'Absender',
  'pages.enquiry.details.contact': 'Kontakt',
  'pages.enquiry.details.email': 'E-Mail',
  'pages.enquiry.details.phone': 'Telefonnummer',
  'pages.enquiry.details.date': 'Erstellungsdatum',
  'pages.enquiry.details.status': 'Status',
  'pages.enquiry.details.shortDesc': 'Kurzbeschreibung',
  'pages.enquiry.details.message': 'Nachricht',
  'pages.enquiry.details.updatedAt': 'Zuletzt aktualisiert',
  'pages.enquiry.deleteDialog.title': 'Anfrage löschen',
  'pages.enquiry.deleteDialog.confirm': 'Sind Sie sicher, dass Sie diese Anfrage löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'pages.enquiry.loading': 'Anfragen werden geladen...',
  'pages.enquiry.loadError': 'Anfragen konnten nicht geladen werden',
  'pages.enquiry.deleteSuccess': 'Anfrage erfolgreich gelöscht',
  'pages.enquiry.deleteError': 'Anfrage konnte nicht gelöscht werden',
  'pages.enquiry.empty': 'Keine Anfragen gefunden',

  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.close': 'Schließen',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.view': 'Ansehen',
  'common.loading': 'Wird geladen…',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',
  'common.free': 'Kostenlos',
  'common.unknownError': 'Unbekannter Fehler',

  'bookingForm.titleCreate': 'Buchung erstellen',
  'bookingForm.titleUpdate': 'Buchung aktualisieren',
  'bookingForm.title': 'Titel',
  'bookingForm.guestDetails': 'Gästedaten',
  'bookingForm.slotAndStatus': 'Zeitfenster und Status',
  'bookingForm.calendarDate': 'Kalenderdatum',
  'bookingForm.slotsFilteredHint': 'Zeitfenster werden nach gewähltem Datum, Monat und Jahr gefiltert.',
  'bookingForm.slot': 'Zeitfenster',
  'bookingForm.contactPerson': 'Service-Ansprechpartner',
  'bookingForm.contactSelect': 'Service',
  'bookingForm.serviceSubcategories': 'Service (Unterkategorien)',
  'bookingForm.noSubcategoriesForContact': 'Keine Unterkategorien für diesen Service; prüfen Sie Kategorie/Unterkategorien in der Service-Liste.',
  'bookingForm.subcategoriesHint': 'Wählen Sie eine oder mehrere Leistungen. Die IDs werden mit der Buchung gespeichert.',
  'bookingForm.subCategoriesRequired': 'Bitte mindestens eine Leistung (Unterkategorie) auswählen.',
  'bookingForm.subCategoryResolveNeedsCategory':
    'Für diesen Service fehlt eine Servicekategorie; ohne sie können Leistungen nicht als IDs gespeichert werden.',
  'bookingForm.subCategoryResolveFailed':
    'Mindestens eine gewählte Leistung konnte keiner Unterkategorie-ID zugeordnet werden.',
  'bookingForm.status': 'Status',
  'bookingForm.guestFirstName': 'Vorname Gast',
  'bookingForm.guestLastName': 'Nachname Gast',
  'bookingForm.guestEmail': 'E-Mail Gast',
  'bookingForm.guestPhone': 'Telefon Gast',
  'bookingForm.gender': 'Geschlecht',
  'bookingForm.numberOfGuests': 'Anzahl Gäste',
  'bookingForm.guestAge': 'Alter',
  'bookingForm.guestAddress': 'Adresse Gast',
  'bookingForm.serviceAddress': 'Service-Adresse',
  'bookingForm.notes': 'Notizen',
  'bookingForm.slotLabel': 'Zeitfenster {{id}}',
  'bookingForm.contactLabel': 'Service {{id}}',
  'bookingForm.errorSelectService': 'Bitte einen Service auswählen.',
  'bookingForm.selectServiceFirst': 'Bitte zuerst einen Service auswählen.',
  'bookingForm.errorSave': 'Fehler beim Erstellen/Aktualisieren der Buchung',

  'pages.bookings.dialog.title': 'Buchungsdetails',
  'pages.bookings.dialog.subtitle': 'Informationen zur ausgewählten Buchung',
  'pages.bookings.dialog.loading': 'Details werden geladen…',
  'pages.bookings.dialog.sectionService': 'Serviceinformationen',
  'pages.bookings.dialog.sectionCustomer': 'Benutzer',
  'pages.bookings.dialog.labelTitle': 'Name',
  'pages.bookings.dialog.labelContactPerson': 'Service-Ansprechpartner',
  'pages.bookings.dialog.labelSubcategories': 'Leistungen',
  'pages.bookings.dialog.labelName': 'Titel',
  'pages.bookings.dialog.labelEmail': 'E-Mail',
  'pages.bookings.dialog.labelPhone': 'Telefon',
  'pages.bookings.dialog.labelGender': 'Geschlecht',
  'pages.bookings.dialog.labelAddress': 'Adresse',

  'pages.contacts.stats.total': 'Kontakte gesamt',
  'pages.contacts.stats.approved': 'Genehmigt',
  'pages.contacts.stats.pending': 'Ausstehend',
  'pages.contacts.stats.declined': 'Abgelehnt',
  'pages.contacts.stats.inactive': 'Inaktiv',
  'pages.contacts.clearFilters': 'Zurücksetzen',
  'pages.contacts.loadingList': 'Kontakte werden geladen…',
  'pages.contacts.searchPlaceholder': 'Suche nach Titel, Service-Ansprechpartner…',
  'pages.contacts.filter.approvalStatus': 'Genehmigungsstatus',
  'pages.contacts.filter.allStatuses': 'Alle Status',
  'pages.contacts.status.approved': 'Genehmigt',
  'pages.contacts.status.pending': 'Ausstehend',
  'pages.contacts.status.declined': 'Abgelehnt',
  'pages.contacts.status.inactive': 'Inaktiv',
  'pages.contacts.tooltip.view': 'Ansehen',
  'pages.contacts.tooltip.edit': 'Bearbeiten',
  'pages.contacts.tooltip.delete': 'Löschen',
  'pages.contacts.tab.general': 'Allgemein',
  'pages.contacts.tab.location': 'Standort',
  'pages.contacts.tab.communication': 'Kommunikation',
  'pages.contacts.tab.business': 'Einstellungen',
  'pages.contacts.tab.info': 'Info',
  'pages.contacts.form.documentsRequired': 'Erforderliche Dokumente',
  'pages.contacts.form.rulesAndRegulations': 'Terms & Conditions',
  'pages.contacts.form.pricingInformation': 'Preisinformationen',
  'pages.contacts.form.pricingInformationDescription': 'Erstellen Sie übersichtliche Tarife mit Preis, Abrechnungszeitraum und Vorteilen.',
  'pages.contacts.form.pricingEmptyTitle': 'Noch keine Tarife hinzugefügt',
  'pages.contacts.form.pricingEmptyDescription': 'Fügen Sie einen Tarif hinzu, damit Kunden Preise und enthaltene Leistungen sehen.',
  'pages.contacts.form.pricingPlan': 'Preismodell',
  'pages.contacts.form.untitledPricingPlan': 'Unbenannter Tarif',
  'pages.contacts.form.removePricingPlan': 'Preismodell entfernen',
  'pages.contacts.form.addPricingPlan': 'Preismodell hinzufügen',
  'pages.contacts.form.pricingHeaderSection': 'Paketinformationen',
  'pages.contacts.form.pricingHeaderTitle': 'Pakettitel',
  'pages.contacts.form.pricingHeaderTitlePlaceholder': 'z. B. Versicherungspakete & Leistungen',
  'pages.contacts.form.pricingHeaderDescription': 'Paketbeschreibung',
  'pages.contacts.form.pricingHeaderDescriptionPlaceholder': 'z. B. Offizielle visumskonforme Pakete für Deutschland',
  'pages.contacts.form.pricingTitle': 'Titel des Preismodells',
  'pages.contacts.form.pricingBadge': 'Kennzeichnung',
  'pages.contacts.form.noPricingBadge': 'Keine Kennzeichnung',
  'pages.contacts.form.badgeMostPopular': 'Am beliebtesten',
  'pages.contacts.form.badgeFlexible': 'Flexibel',
  'pages.contacts.form.pricingDescription': 'Beschreibung',
  'pages.contacts.form.pricingPrice': 'Preis',
  'pages.contacts.form.pricingPeriod': 'Zeitraum',
  'pages.contacts.form.periodMonth': 'Monatlich',
  'pages.contacts.form.periodYear': 'Jährlich',
  'pages.contacts.form.periodWeek': 'Wöchentlich',
  'pages.contacts.form.periodDay': 'Täglich',
  'pages.contacts.form.periodOneTime': 'Einmalig',
  'pages.contacts.form.periodSession': 'Pro Sitzung',
  'pages.contacts.form.periodConsultation': 'Pro Beratung',
  'pages.contacts.form.periodFree': 'Kostenlos',
  'pages.contacts.form.pricingHint': 'Preishinweis',
  'pages.contacts.form.pricingHighlights': 'Vorteile',
  'pages.contacts.form.pricingHighlightPlaceholder': 'Vorteil hinzufügen...',
  'pages.contacts.form.documentsRequiredPlaceholder': 'z.B. Personalausweis, Gewerbeanmeldung...',
  'pages.contacts.form.rulesAndRegulationsPlaceholder': 'z.B. Bedingungen, Stornierungsbedingungen...',
  'pages.contacts.form.addSession': 'Sitzung hinzufügen',
  'pages.contacts.form.closed': 'Geschlossen',
  'pages.contacts.form.removeSession': 'Sitzung entfernen',
  'pages.contacts.form.businessTitle': 'Geschäftstitel',
  'pages.contacts.form.contactPerson': 'Service-Ansprechpartner',
  'pages.contacts.form.description': 'Beschreibung',
  'pages.contacts.form.infoNote': 'Zusätzliche Infos',
  'pages.contacts.form.infoPlaceholder': 'Interne oder geteilte Notizen…',
  'pages.contacts.form.supportLanguages': 'Unterstützte Sprachen',
  'pages.contacts.form.supportLangPlaceholder': 'Englisch, Deutsch',
  'pages.contacts.form.callToAction': 'Handlungsaufforderung',
  'pages.contacts.form.callToActionPlaceholder': 'z.B. Hier klicken, Registrieren...',
  'pages.contacts.form.clientTypes': 'Kundentypen',
  'pages.contacts.form.clientTypesPlaceholder': 'Erwachsene, Kinder, Senioren',
  'pages.contacts.form.subcategories': 'Unterkategorien',
  'pages.contacts.form.streetAddress': 'Straße',
  'pages.contacts.form.houseNo': 'Hausnr.',
  'pages.contacts.form.zip': 'PLZ',
  'pages.contacts.form.zipPlaceholder': '5 Ziffern',
  'pages.contacts.form.city': 'Stadt',
  'pages.contacts.form.district': 'Bezirk',
  'pages.contacts.form.selectCity': 'Stadt auswählen',
  'pages.contacts.form.selectDistrict': 'Bezirk auswählen',
  'pages.contacts.form.longitude': 'Längengrad',
  'pages.contacts.form.latPlaceholder': 'z. B. 52,535188',
  'pages.contacts.form.lonPlaceholder': 'z. B. 13,42535',
  'pages.contacts.form.latitude': 'Breitengrad',
  'pages.contacts.form.email': 'E-Mail-Adresse',
  'pages.contacts.form.phone': 'Telefonnummer',
  'pages.contacts.form.whatsapp': 'WhatsApp',
  'pages.contacts.form.website': 'Website-URL',
  'pages.contacts.form.whatsappTemplate': 'WhatsApp-Nachrichtenvorlage',
  'pages.contacts.form.businessHours': 'Öffnungszeiten',
  'common.days.monday': 'Montag',
  'common.days.tuesday': 'Dienstag',
  'common.days.wednesday': 'Mittwoch',
  'common.days.thursday': 'Donnerstag',
  'common.days.friday': 'Freitag',
  'common.days.saturday': 'Samstag',
  'common.days.sunday': 'Sonntag',
  'pages.contacts.form.hoursPlaceholder': 'Mo–Fr: 9:00–18:00…',
  'pages.contacts.form.bannerImages': 'Banner-Bilder',
  'pages.contacts.form.savedImages': 'Gespeicherte Bilder:',
  'pages.contacts.form.logo': 'Logo',
  'pages.contacts.form.savedLogo': 'Gespeichertes Logo:',
  'pages.contacts.form.addBanner': 'Hinzufügen',
  'pages.contacts.form.addLogo': 'Hinzufügen',
  'pages.contacts.form.changeLogo': 'Ändern',
  'pages.contacts.form.removeBanner': 'Banner entfernen',
  'pages.contacts.form.removeSavedBanner': 'Gespeichertes Banner entfernen',
  'pages.contacts.form.removeLogo': 'Neues Logo entfernen',
  'pages.contacts.form.removeSavedLogo': 'Gespeichertes Logo entfernen',
  'pages.contacts.form.isActive': 'isActive: {{value}}',
  'pages.contacts.form.bookingAppointments': 'Terminbuchung',
  'pages.contacts.form.isBookingAppointmentExist': 'Buchungstermin vorhanden',
  'pages.contacts.form.isServiceBased': 'Servicebasiert',
  'pages.contacts.form.isChatEnabled': 'Chat-Support',
  'pages.contacts.card.appointmentsOn': 'Buchungen an',
  'pages.contacts.approval.reasonDecline': 'Grund für Ablehnung',
  'pages.contacts.approval.reasonRequired': 'Grund ist erforderlich',
  'pages.contacts.validation.titleRequired': 'Titel ist erforderlich.',
  'pages.contacts.validation.titleLength': 'Titel darf 250 Zeichen nicht überschreiten.',
  'pages.contacts.validation.contactPersonRequired': 'Service-Ansprechpartner ist erforderlich.',
  'pages.contacts.validation.callToActionLength': 'Handlungsaufforderung darf 30 Zeichen nicht überschreiten.',
  'pages.contacts.dialog.close': 'Schließen',
  'pages.contacts.dialog.saveChanges': 'Änderungen speichern',
  'pages.contacts.dialog.addContact': 'Service hinzufügen',
  'pages.contacts.dialog.editContact': 'Service bearbeiten',
  'pages.contacts.dialog.saving': 'Wird gespeichert…',
  'pages.contacts.dialog.adding': 'Wird hinzugefügt…',
  'pages.contacts.dialog.switchToEdit': 'Zur Bearbeitung wechseln',
  'pages.contacts.wizard.next': 'Weiter',
  'pages.contacts.wizard.previous': 'Zurück',
  'pages.contacts.wizard.createContact': 'Service erstellen',

  'pages.slots.addSlot': 'Zeitfenster hinzufügen',
  'pages.slots.stats.total': 'Zeitfenster gesamt',
  'pages.slots.stats.available': 'Verfügbar',
  'pages.slots.stats.booked': 'Gebucht',
  'pages.slots.stats.confirmed': 'Bestätigt',
  'pages.slots.stats.today': 'Heutige Zeitfenster',
  'pages.slots.filter.contact': 'Kontakt',
  'pages.slots.filter.template': 'Vorlage',
  'pages.slots.filter.startDate': 'Startdatum',
  'pages.slots.filter.endDate': 'Enddatum',
  'pages.slots.table.actions': 'Aktionen',
  'pages.slots.empty.title': 'Keine Zeitfenster gefunden',
  'pages.slots.empty.hint': 'Passen Sie die Filter an oder legen Sie ein neues Zeitfenster an.',
  'pages.slots.empty.subline': 'Erstellen Sie Zeitfenster, um zu starten.',
  'pages.slots.filter.allContacts': 'Alle Kontakte',
  'pages.slots.filter.allTemplates': 'Alle Vorlagen',
  'pages.slots.clearFilters': 'Zurücksetzen',
  'pages.slots.generate.title': 'Mehrere Zeitfenster generieren',
  'pages.slots.generate.now': 'Jetzt generieren',
  'pages.slots.generate.subtitle': 'Schnell Verfügbarkeit für einen Datumsbereich erstellen',
  'pages.slots.rowsPerPage': 'Zeitfenster pro Seite:',
  'pages.slots.form.templateOptional': 'Vorlage (optional)',
  'pages.slots.form.pastDates': 'Vergangene Daten sind nicht wählbar',
  'pages.slots.form.endAfterStart': 'Muss am oder nach dem Startdatum liegen',
  'pages.slots.form.startTime': 'Startzeit',
  'pages.slots.form.endTime': 'Endzeit',
  'pages.slots.form.durationMin': 'Dauer (Minuten)',
  'pages.slots.form.daysOfWeek': 'Wochentage',
  'pages.slots.form.slotTitle': 'Titel',
  'pages.slots.form.description': 'Beschreibung',
  'pages.slots.form.price': 'Preis',
  'pages.slots.form.bookingType': 'Buchungsart',
  'pages.slots.form.maxSlotsPerDay': 'Max. Zeitfenster pro Tag',
  'pages.slots.form.location': 'Ort',
  'pages.slots.form.excludeHolidays': 'Feiertage ausschließen',
  'pages.slots.form.isRecurring': 'Wiederkehrend',
  'pages.slots.form.generate': 'Zeitfenster generieren',
  'pages.slots.form.templateOptional2': 'Vorlage (optional)',
  'pages.slots.form.durationHelp': 'Automatisch aus Start- und Endzeit berechnet (muss für den Server übereinstimmen)',
  'pages.slots.form.maxCapacity': 'Max. Kapazität',
  'pages.slots.form.maxCapacityHelp': 'Anzahl Personen, die dieses Zeitfenster buchen können',
  'pages.slots.form.slotTitleLabel': 'Titel des Zeitfensters',
  'pages.slots.form.slotTitleHelp': 'z. B. Allgemeine Beratung',
  'pages.slots.form.contactLoadsTemplateTitle': 'Bei Kontaktauswahl wird die Buchungsvorlage (falls vorhanden) in Titel und zugehörige Felder übernommen.',
  'pages.slots.btn.createSlot': 'Zeitfenster erstellen',
  'pages.slots.btn.saveChanges': 'Änderungen speichern',
  'pages.slots.validation.maxCapacity': 'Die maximale Kapazität darf 1000 nicht überschreiten.',

  'pages.bookingTemplates.newTemplate': 'Neue Vorlage',
  'pages.bookingTemplates.stats.total': 'Vorlagen gesamt',
  'pages.bookingTemplates.stats.autoApproved': 'Auto-genehmigt',
  'pages.bookingTemplates.stats.totalBookings': 'Buchungen gesamt',
  'pages.bookingTemplates.stats.avgDuration': 'Ø Dauer (Min.)',
  'pages.bookingTemplates.loading': 'Vorlagen werden geladen…',
  'pages.bookingTemplates.empty.title': 'Noch keine Vorlagen',
  'pages.bookingTemplates.empty.hint': 'Legen Sie Ihre erste Buchungsvorlage an, um Verfügbarkeit, Preise und Einstellungen für Ihre Services zu definieren.',
  'pages.bookingTemplates.card.active': 'Aktiv',
  'pages.bookingTemplates.card.inactive': 'Inaktiv',
  'pages.bookingTemplates.card.minutes': '{{n}} Minuten',
  'pages.bookingTemplates.card.maxParticipants': 'Max. {{n}} Teilnehmer',
  'pages.bookingTemplates.card.maxParticipantsPlural': 'Max. {{n}} Teilnehmer',
  'pages.bookingTemplates.card.bookings': '{{n}} Buchungen',
  'pages.bookingTemplates.card.assignedUsers': 'Zugewiesene Benutzer:',
  'pages.bookingTemplates.card.noContact': 'Kein Kontakt zugewiesen',
  'pages.bookingTemplates.approval.auto': 'Auto-genehmigt',
  'pages.bookingTemplates.approval.manual': 'Manuelle Freigabe',
  'pages.bookingTemplates.approval.partial': 'Teilweise Freigabe',
  'pages.bookingTemplates.deactivate': 'Deaktivieren',
  'pages.bookingTemplates.activate': 'Aktivieren',
  'pages.bookingTemplates.dialog.view': 'Ansehen',
  'pages.bookingTemplates.dialog.edit': 'Bearbeiten',
  'pages.bookingTemplates.dialog.create': 'Erstellen',
  'pages.bookingTemplates.dialog.title': '{{action}} Buchungsvorlage',
  'pages.bookingTemplates.switchToEdit': 'Zur Bearbeitung wechseln',
  'pages.bookingTemplates.tab.general': 'Allgemein',
  'pages.bookingTemplates.tab.availability': 'Verfügbarkeit',
  'pages.bookingTemplates.tab.settings': 'Einstellungen',
  'pages.bookingTemplates.tab.pricing': 'Preise',
  'pages.bookingTemplates.field.templateName': 'Vorlagenname',
  'pages.bookingTemplates.field.description': 'Beschreibung',
  'pages.bookingTemplates.field.duration': 'Dauer (Minuten)',
  'pages.bookingTemplates.field.maxParticipants': 'Max. Teilnehmer',
  'pages.bookingTemplates.field.approvalType': 'Freigabetyp',
  'pages.bookingTemplates.field.approvalHelp': 'Wie Buchungen freigegeben werden',
  'pages.bookingTemplates.menu.approvalAuto': 'Automatisch',
  'pages.bookingTemplates.menu.approvalManual': 'Manuell',
  'pages.bookingTemplates.menu.approvalPartial': 'Teilweise',
  'pages.bookingTemplates.assignUsersTitle': 'Benutzer der Vorlage zuweisen',
  'pages.bookingTemplates.assignUsersHint': 'Wählen Sie, welche Benutzer Buchungen für diese Vorlage bearbeiten können.',
  'pages.bookingTemplates.noContacts': 'Keine Kontakte vorhanden. Bitte zuerst Kontakte anlegen.',
  'pages.bookingTemplates.field.active': 'Aktiv',
  'pages.bookingTemplates.field.maxAdvanceDays': 'Max. Vorlauf (Tage)',
  'pages.bookingTemplates.field.maxAdvanceHelp': 'Wie weit im Voraus gebucht werden kann',
  'pages.bookingTemplates.field.minAdvanceHours': 'Min. Vorlauf (Stunden)',
  'pages.bookingTemplates.field.minAdvanceHelp': 'Mindestvorlauf für eine Buchung',
  'pages.bookingTemplates.field.buffer': 'Pufferzeit (Minuten)',
  'pages.bookingTemplates.field.bufferHelp': 'Zeit zwischen Buchungen',
  'pages.bookingTemplates.workingHours': 'Arbeitszeiten',
  'pages.bookingTemplates.field.enabled': 'Aktiv',
  'pages.bookingTemplates.field.workingHoursStart': 'Startzeit',
  'pages.bookingTemplates.field.workingHoursEnd': 'Endzeit',
  'pages.bookingTemplates.day.monday': 'Montag',
  'pages.bookingTemplates.day.tuesday': 'Dienstag',
  'pages.bookingTemplates.day.wednesday': 'Mittwoch',
  'pages.bookingTemplates.day.thursday': 'Donnerstag',
  'pages.bookingTemplates.day.friday': 'Freitag',
  'pages.bookingTemplates.day.saturday': 'Samstag',
  'pages.bookingTemplates.day.sunday': 'Sonntag',
  'pages.bookingTemplates.settings.allowCancel': 'Stornierung erlauben',
  'pages.bookingTemplates.settings.cancelDeadline': 'Stornierungsfrist (Stunden)',
  'pages.bookingTemplates.settings.cancelHelp': 'Stunden vor dem Termin, in denen Stornierung möglich ist',
  'pages.bookingTemplates.settings.requiresDeposit': 'Anzahlung erforderlich',
  'pages.bookingTemplates.settings.depositAmount': 'Anzahlungsbetrag',
  'pages.bookingTemplates.settings.autoReminders': 'Automatische Erinnerungen',
  'pages.bookingTemplates.settings.reminderTitle': 'Erinnerungszeiten (Stunden vor dem Termin)',
  'pages.bookingTemplates.settings.hoursChip': '{{n}} Stunden',
  'pages.bookingTemplates.settings.hoursLabel': 'Stunden',
  'pages.bookingTemplates.settings.add': 'Hinzufügen',
  'pages.bookingTemplates.pricing.none': 'Kein Preis',
  'pages.bookingTemplates.pricing.fixed': 'Festpreis',
  'pages.bookingTemplates.pricing.range': 'Preisspanne',
  'pages.bookingTemplates.field.price': 'Preis',
  'pages.bookingTemplates.field.minPrice': 'Mindestpreis',
  'pages.bookingTemplates.field.maxPrice': 'Höchstpreis',
  'pages.bookingTemplates.actions.close': 'Schließen',
  'pages.bookingTemplates.actions.saveChanges': 'Änderungen speichern',
  'pages.bookingTemplates.actions.create': 'Vorlage erstellen',
  'pages.bookingTemplates.wizard.next': 'Weiter',
  'pages.bookingTemplates.wizard.previous': 'Zurück',
  'pages.bookingTemplates.wizard.createBooking': 'Buchung erstellen',
  'pages.bookingTemplates.validation.required': 'Erforderlich',
  'pages.bookingTemplates.validation.wholeNumber': 'Muss eine ganze Zahl sein',
  'pages.bookingTemplates.validation.minOne': 'Mindestens 1',
  'pages.bookingTemplates.validation.durationRange': 'Die Dauer muss zwischen 15 und 1440 Minuten liegen',
  'pages.bookingTemplates.validation.maxParticipantsRange': 'Maximale Teilnehmerzahl darf 5000 nicht überschreiten',
  'pages.bookingTemplates.validation.nonNegative': 'Muss 0 oder größer sein',
  'pages.bookingTemplates.validation.invalidTime': 'Bitte gültige Start- und Endzeit eingeben',
  'pages.bookingTemplates.validation.endAfterStart': 'Endzeit muss nach der Startzeit liegen',
  'pages.bookingTemplates.validation.minAdvanceVsMax': 'Mindestvorlauf (Std.) darf den maximalen Vorlauf (Tage × 24) nicht überschreiten',
  'pages.bookingTemplates.validation.maxAdvanceDaysRange': 'Muss zwischen 1 und 60 Tagen liegen',
  'pages.bookingTemplates.validation.minAdvanceHoursRange': 'Muss zwischen 1 und 24 Stunden liegen',
  'pages.bookingTemplates.validation.bufferTimeRange': 'Muss zwischen 0 und 60 Minuten liegen',
  'pages.bookingTemplates.validation.depositPositive': 'Anzahlungsbetrag muss größer als 0 sein',
  'pages.bookingTemplates.validation.atLeastOneReminder': 'Mindestens eine Erinnerungszeit hinzufügen',
  'pages.bookingTemplates.validation.priceRangeOrder': 'Höchstpreis muss größer oder gleich Mindestpreis sein',
  'pages.bookingTemplates.error.loadFailed': 'Vorlagen konnten nicht geladen werden',
  'pages.bookingTemplates.error.fetch': 'Fehler beim Laden der Vorlagen',
  'pages.bookingTemplates.toast.selectContact': 'Bitte einen Kontakt für diese Vorlage wählen',
  'pages.bookingTemplates.toast.contactIdUpdate': 'Kontakt-ID ist für die Aktualisierung erforderlich',
  'pages.bookingTemplates.toast.updated': 'Vorlage erfolgreich aktualisiert',
  'pages.bookingTemplates.toast.created': 'Vorlage erfolgreich erstellt',
  'pages.bookingTemplates.toast.saveFailed': 'Vorlage konnte nicht gespeichert werden',
  'pages.bookingTemplates.toast.contactIdDelete': 'Kontakt-ID ist zum Löschen erforderlich',
  'pages.bookingTemplates.confirm.delete': 'Diese Vorlage wirklich löschen?',
  'pages.bookingTemplates.toast.deleted': 'Vorlage erfolgreich gelöscht',
  'pages.bookingTemplates.toast.deleteFailed': 'Vorlage konnte nicht gelöscht werden',
  'pages.bookingTemplates.toast.contactIdToggle': 'Kontakt-ID ist für die Statusänderung erforderlich',
  'pages.bookingTemplates.toast.toggleActivated': 'Vorlage erfolgreich aktiviert',
  'pages.bookingTemplates.toast.toggleDeactivated': 'Vorlage erfolgreich deaktiviert',
  'pages.bookingTemplates.toast.toggleFailed': 'Status konnte nicht geändert werden',
  'pages.bookingTemplates.toast.contactIdEdit': 'Kontakt-ID ist für die Bearbeitung erforderlich',
  'pages.bookingTemplates.toast.loadEditFailed': 'Vorlage konnte nicht zum Bearbeiten geladen werden',
  'pages.bookingTemplates.toast.contactIdView': 'Kontakt-ID ist zum Ansehen erforderlich',
  'pages.bookingTemplates.toast.loadViewFailed': 'Vorlage konnte nicht geladen werden',
  'common.validation.passwordTooShort': 'Das Passwort muss mindestens 8 Zeichen lang sein',
  'common.validation.passwordTooLong': 'Das Passwort darf maximal 12 Zeichen lang sein',
  'common.validation.passwordWeak': 'Das Passwort muss Groß- und Kleinschreibung, Zahlen und Sonderzeichen enthalten (@$!%*?&#)',
  'pages.bookings.dialog.notifyCustomerHint': 'Der Kunde erhält eine Transferbestätigung',
  'common.date': 'Datum',
  'pages.promotions.title': 'Promotionsmanagement',
  'pages.promotions.subtitle': 'Verwalten und organisieren Sie Ihre Werbeaktionen und Rabattangebote',
  'pages.promotions.searchPlaceholder': 'Suchen nach Titel, Ansprechpartner...',
  'pages.promotions.addBtn': '+ Promotion hinzufügen',
  'pages.promotions.editTitle': 'Promotion bearbeiten',
  'pages.promotions.addTitle': 'Promotion hinzufügen',
  'pages.promotions.deleteTitle': 'Promotion löschen',
  'pages.promotions.confirmDelete': 'Sind Sie sicher, dass Sie diese Promotion löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'pages.promotions.filter.statusAll': 'Genehmigungsstatus',
  'pages.promotions.filter.statusActive': 'Aktiv',
  'pages.promotions.filter.statusInactive': 'Inaktiv',
  'pages.promotions.filter.clear': 'Zurücksetzen',
  'pages.promotions.empty.title': 'Keine Promotionen gefunden',
  'pages.promotions.empty.hint': 'Klicken Sie oben auf "+ Promotion hinzufügen", um Ihr erstes Angebot zu erstellen.',
  'pages.promotions.card.city': 'Stadt',
  'pages.promotions.card.coupon': 'Gutschein',
  'pages.promotions.card.active': 'Aktiv',
  'pages.promotions.card.inactive': 'Inaktiv',
  'pages.promotions.card.deactivate': 'Deaktivieren',
  'pages.promotions.card.activate': 'Aktivieren',
  'pages.promotions.card.edit': 'Promotion bearbeiten',
  'pages.promotions.card.delete': 'Promotion löschen',
  'pages.promotions.card.defaultBanner': 'GetSettled-Promotion',
  'pages.promotions.card.defaultType': 'Promotion',
  'pages.promotions.card.copyCoupon': 'Gutscheincode kopieren',
  'pages.promotions.card.mobilePreview': 'Mobile Vorschau',
  'pages.promotions.status.approved': 'GENEHMIGT',
  'pages.promotions.status.pending': 'AUSSTEHEND',
  'pages.promotions.status.rejected': 'ABGELEHNT',
  'pages.promotions.validation.titleRequired': 'Promotion-Titel ist erforderlich',
  'pages.promotions.validation.titleMinLength': 'Titel muss mindestens 3 Zeichen lang sein',
  'pages.promotions.validation.descriptionRequired': 'Beschreibung ist erforderlich',
  'pages.promotions.validation.cityRequired': 'Stadt ist erforderlich',
  'pages.promotions.validation.dateRequired': 'Promotion-Datum ist erforderlich',
  'pages.promotions.validation.webUrlInvalid': 'Bitte geben Sie eine gültige URL ein (z. B. https://example.com/angebot)',
  'pages.promotions.validation.sharingUrlInvalid': 'Bitte geben Sie eine gültige URL ein (z. B. https://example.com/teilen)',
  'pages.promotions.toast.couponCopied': 'Gutscheincode "{{code}}" in die Zwischenablage kopiert!',
  'pages.promotions.toast.fillRequired': 'Bitte füllen Sie alle Pflichtfelder aus',
  'pages.promotions.toast.updateSuccess': 'Promotion erfolgreich aktualisiert',
  'pages.promotions.toast.createSuccess': 'Promotion erfolgreich erstellt',
  'pages.promotions.toast.activated': 'Promotion aktiviert',
  'pages.promotions.toast.deactivated': 'Promotion deaktiviert',
  'pages.promotions.toast.deleteSuccess': 'Promotion erfolgreich gelöscht',
  'pages.promotions.toast.saveFailed': 'Promotion konnte nicht gespeichert werden',
  'pages.slots.generate.title': 'Mehrere Zeitfenster generieren',
  'pages.slots.generate.now': 'Jetzt generieren',
  'pages.slots.generate.subtitle': 'Schnell Verfügbarkeit für einen Datumsbereich erstellen',
  'pages.slots.rowsPerPage': 'Zeitfenster pro Seite:',
  'pages.slots.form.templateOptional': 'Vorlage (optional)',
  'pages.slots.form.pastDates': 'Vergangene Daten sind nicht wählbar',
  'pages.slots.form.endAfterStart': 'Muss am oder nach dem Startdatum liegen',
  'pages.slots.form.startTime': 'Startzeit',
  'pages.slots.form.endTime': 'Endzeit',
  'pages.slots.form.durationMin': 'Dauer (Minuten)',
  'pages.slots.form.daysOfWeek': 'Wochentage',
  'pages.slots.form.slotTitle': 'Titel',
  'pages.slots.form.description': 'Beschreibung',
  'pages.slots.form.price': 'Preis',
  'pages.slots.form.bookingType': 'Buchungsart',
  'pages.slots.form.maxSlotsPerDay': 'Max. Zeitfenster pro Tag',
  'pages.slots.form.location': 'Ort',
  'pages.slots.form.excludeHolidays': 'Feiertage ausschließen',
  'pages.slots.form.isRecurring': 'Wiederkehrend',
  'pages.slots.form.generate': 'Zeitfenster generieren',
  'pages.slots.form.templateOptional2': 'Vorlage (optional)',
  'pages.slots.form.durationHelp': 'Automatisch aus Start- und Endzeit berechnet (muss für den Server übereinstimmen)',
  'pages.slots.form.maxCapacity': 'Max. Kapazität',
  'pages.slots.form.maxCapacityHelp': 'Anzahl Personen, die dieses Zeitfenster buchen können',
  'pages.slots.form.slotTitleLabel': 'Titel des Zeitfensters',
  'pages.slots.form.slotTitleHelp': 'z. B. Allgemeine Beratung',
  'pages.slots.form.contactLoadsTemplateTitle': 'Bei Kontaktauswahl wird die Buchungsvorlage (falls vorhanden) in Titel und zugehörige Felder übernommen.',
  'pages.slots.btn.createSlot': 'Zeitfenster erstellen',
  'pages.slots.btn.saveChanges': 'Änderungen speichern',
  'pages.slots.validation.maxCapacity': 'Die maximale Kapazität darf 1000 nicht überschreiten.',

  'pages.bookingTemplates.newTemplate': 'Neue Vorlage',
  'pages.bookingTemplates.stats.total': 'Vorlagen gesamt',
  'pages.bookingTemplates.stats.autoApproved': 'Auto-genehmigt',
  'pages.bookingTemplates.stats.totalBookings': 'Buchungen gesamt',
  'pages.bookingTemplates.stats.avgDuration': 'Ø Dauer (Min.)',
  'pages.bookingTemplates.loading': 'Vorlagen werden geladen…',
  'pages.bookingTemplates.empty.title': 'Noch keine Vorlagen',
  'pages.bookingTemplates.empty.hint': 'Legen Sie Ihre erste Buchungsvorlage an, um Verfügbarkeit, Preise und Einstellungen für Ihre Services zu definieren.',
  'pages.bookingTemplates.card.active': 'Aktiv',
  'pages.bookingTemplates.card.inactive': 'Inaktiv',
  'pages.bookingTemplates.card.minutes': '{{n}} Minuten',
  'pages.bookingTemplates.card.maxParticipants': 'Max. {{n}} Teilnehmer',
  'pages.bookingTemplates.card.maxParticipantsPlural': 'Max. {{n}} Teilnehmer',
  'pages.bookingTemplates.card.bookings': '{{n}} Buchungen',
  'pages.bookingTemplates.card.assignedUsers': 'Zugewiesene Benutzer:',
  'pages.bookingTemplates.card.noContact': 'Kein Kontakt zugewiesen',
  'pages.bookingTemplates.approval.auto': 'Auto-genehmigt',
  'pages.bookingTemplates.approval.manual': 'Manuelle Freigabe',
  'pages.bookingTemplates.approval.partial': 'Teilweise Freigabe',
  'pages.bookingTemplates.deactivate': 'Deaktivieren',
  'pages.bookingTemplates.activate': 'Aktivieren',
  'pages.bookingTemplates.dialog.view': 'Ansehen',
  'pages.bookingTemplates.dialog.edit': 'Bearbeiten',
  'pages.bookingTemplates.dialog.create': 'Erstellen',
  'pages.bookingTemplates.dialog.title': '{{action}} Buchungsvorlage',
  'pages.bookingTemplates.switchToEdit': 'Zur Bearbeitung wechseln',
  'pages.bookingTemplates.tab.general': 'Allgemein',
  'pages.bookingTemplates.tab.availability': 'Verfügbarkeit',
  'pages.bookingTemplates.tab.settings': 'Einstellungen',
  'pages.bookingTemplates.tab.pricing': 'Preise',
  'pages.bookingTemplates.field.templateName': 'Vorlagenname',
  'pages.bookingTemplates.field.description': 'Beschreibung',
  'pages.bookingTemplates.field.duration': 'Dauer (Minuten)',
  'pages.bookingTemplates.field.maxParticipants': 'Max. Teilnehmer',
  'pages.bookingTemplates.field.approvalType': 'Freigabetyp',
  'pages.bookingTemplates.field.approvalHelp': 'Wie Buchungen freigegeben werden',
  'pages.bookingTemplates.menu.approvalAuto': 'Automatisch',
  'pages.bookingTemplates.menu.approvalManual': 'Manuell',
  'pages.bookingTemplates.menu.approvalPartial': 'Teilweise',
  'pages.bookingTemplates.assignUsersTitle': 'Benutzer der Vorlage zuweisen',
  'pages.bookingTemplates.assignUsersHint': 'Wählen Sie, welche Benutzer Buchungen für diese Vorlage bearbeiten können.',
  'pages.bookingTemplates.noContacts': 'Keine Kontakte vorhanden. Bitte zuerst Kontakte anlegen.',
  'pages.bookingTemplates.field.active': 'Aktiv',
  'pages.bookingTemplates.field.maxAdvanceDays': 'Max. Vorlauf (Tage)',
  'pages.bookingTemplates.field.maxAdvanceHelp': 'Wie weit im Voraus gebucht werden kann',
  'pages.bookingTemplates.field.minAdvanceHours': 'Min. Vorlauf (Stunden)',
  'pages.bookingTemplates.field.minAdvanceHelp': 'Mindestvorlauf für eine Buchung',
  'pages.bookingTemplates.field.buffer': 'Pufferzeit (Minuten)',
  'pages.bookingTemplates.field.bufferHelp': 'Zeit zwischen Buchungen',
  'pages.bookingTemplates.workingHours': 'Arbeitszeiten',
  'pages.bookingTemplates.field.enabled': 'Aktiv',
  'pages.bookingTemplates.field.workingHoursStart': 'Startzeit',
  'pages.bookingTemplates.field.workingHoursEnd': 'Endzeit',
  'pages.bookingTemplates.day.monday': 'Montag',
  'pages.bookingTemplates.day.tuesday': 'Dienstag',
  'pages.bookingTemplates.day.wednesday': 'Mittwoch',
  'pages.bookingTemplates.day.thursday': 'Donnerstag',
  'pages.bookingTemplates.day.friday': 'Freitag',
  'pages.bookingTemplates.day.saturday': 'Samstag',
  'pages.bookingTemplates.day.sunday': 'Sonntag',
  'pages.bookingTemplates.settings.allowCancel': 'Stornierung erlauben',
  'pages.bookingTemplates.settings.cancelDeadline': 'Stornierungsfrist (Stunden)',
  'pages.bookingTemplates.settings.cancelHelp': 'Stunden vor dem Termin, in denen Stornierung möglich ist',
  'pages.bookingTemplates.settings.requiresDeposit': 'Anzahlung erforderlich',
  'pages.bookingTemplates.settings.depositAmount': 'Anzahlungsbetrag',
  'pages.bookingTemplates.settings.autoReminders': 'Automatische Erinnerungen',
  'pages.bookingTemplates.settings.reminderTitle': 'Erinnerungszeiten (Stunden vor dem Termin)',
  'pages.bookingTemplates.settings.hoursChip': '{{n}} Stunden',
  'pages.bookingTemplates.settings.hoursLabel': 'Stunden',
  'pages.bookingTemplates.settings.add': 'Hinzufügen',
  'pages.bookingTemplates.pricing.none': 'Kein Preis',
  'pages.bookingTemplates.pricing.fixed': 'Festpreis',
  'pages.bookingTemplates.pricing.range': 'Preisspanne',
  'pages.bookingTemplates.field.price': 'Preis',
  'pages.bookingTemplates.field.minPrice': 'Mindestpreis',
  'pages.bookingTemplates.field.maxPrice': 'Höchstpreis',
  'pages.bookingTemplates.actions.close': 'Schließen',
  'pages.bookingTemplates.actions.saveChanges': 'Änderungen speichern',
  'pages.bookingTemplates.actions.create': 'Vorlage erstellen',
  'pages.bookingTemplates.wizard.next': 'Weiter',
  'pages.bookingTemplates.wizard.previous': 'Zurück',
  'pages.bookingTemplates.wizard.createBooking': 'Buchung erstellen',
  'pages.bookingTemplates.validation.required': 'Erforderlich',
  'pages.bookingTemplates.validation.wholeNumber': 'Muss eine ganze Zahl sein',
  'pages.bookingTemplates.validation.minOne': 'Mindestens 1',
  'pages.bookingTemplates.validation.durationRange': 'Die Dauer muss zwischen 15 und 1440 Minuten liegen',
  'pages.bookingTemplates.validation.maxParticipantsRange': 'Maximale Teilnehmerzahl darf 5000 nicht überschreiten',
  'pages.bookingTemplates.validation.nonNegative': 'Muss 0 oder größer sein',
  'pages.bookingTemplates.validation.invalidTime': 'Bitte gültige Start- und Endzeit eingeben',
  'pages.bookingTemplates.validation.endAfterStart': 'Endzeit muss nach der Startzeit liegen',
  'pages.bookingTemplates.validation.minAdvanceVsMax': 'Mindestvorlauf (Std.) darf den maximalen Vorlauf (Tage × 24) nicht überschreiten',
  'pages.bookingTemplates.validation.maxAdvanceDaysRange': 'Muss zwischen 1 und 60 Tagen liegen',
  'pages.bookingTemplates.validation.minAdvanceHoursRange': 'Muss zwischen 1 und 24 Stunden liegen',
  'pages.bookingTemplates.validation.bufferTimeRange': 'Muss zwischen 0 und 60 Minuten liegen',
  'pages.bookingTemplates.validation.depositPositive': 'Anzahlungsbetrag muss größer als 0 sein',
  'pages.bookingTemplates.validation.atLeastOneReminder': 'Mindestens eine Erinnerungszeit hinzufügen',
  'pages.bookingTemplates.validation.priceRangeOrder': 'Höchstpreis muss größer oder gleich Mindestpreis sein',
  'pages.bookingTemplates.error.loadFailed': 'Vorlagen konnten nicht geladen werden',
  'pages.bookingTemplates.error.fetch': 'Fehler beim Laden der Vorlagen',
  'pages.bookingTemplates.toast.selectContact': 'Bitte einen Kontakt für diese Vorlage wählen',
  'pages.bookingTemplates.toast.contactIdUpdate': 'Kontakt-ID ist für die Aktualisierung erforderlich',
  'pages.bookingTemplates.toast.updated': 'Vorlage erfolgreich aktualisiert',
  'pages.bookingTemplates.toast.created': 'Vorlage erfolgreich erstellt',
  'pages.bookingTemplates.toast.saveFailed': 'Vorlage konnte nicht gespeichert werden',
  'pages.bookingTemplates.confirm.deleteTitle': 'Buchungsvorlage löschen',
  'pages.bookingTemplates.confirm.delete': 'Sind Sie sicher, dass Sie diese Buchungsvorlage löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'pages.bookingTemplates.btn.cancel': 'Abbrechen',
  'pages.bookingTemplates.btn.delete': 'Löschen',
  'pages.contacts.confirm.deleteTitle': 'Kontakt löschen',
  'pages.contacts.confirm.delete': 'Sind Sie sicher, dass Sie diesen Kontakt löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'pages.contacts.btn.cancel': 'Abbrechen',
  'pages.contacts.btn.delete': 'Löschen',
  'pages.bookingTemplates.toast.deleted': 'Vorlage erfolgreich gelöscht',
  'pages.bookingTemplates.toast.deleteFailed': 'Vorlage konnte nicht gelöscht werden',
  'pages.bookingTemplates.toast.contactIdToggle': 'Kontakt-ID ist für die Statusänderung erforderlich',
  'pages.bookingTemplates.toast.toggleActivated': 'Vorlage erfolgreich aktiviert',
  'pages.bookingTemplates.toast.toggleDeactivated': 'Vorlage erfolgreich deaktiviert',
  'pages.bookingTemplates.toast.toggleFailed': 'Status konnte nicht geändert werden',
  'pages.promotions.title': 'Promotionsmanagement',
  'pages.promotions.subtitle': 'Verwalten und organisieren Sie Ihre Werbeaktionen und Rabattangebote',
  'pages.promotions.searchPlaceholder': 'Suchen nach Titel, Ansprechpartner...',
  'pages.promotions.addBtn': '+ Promotion hinzufügen',
  'pages.promotions.editTitle': 'Promotion bearbeiten',
  'pages.promotions.addTitle': 'Promotion hinzufügen',
  'pages.promotions.deleteTitle': 'Promotion löschen',
  'pages.promotions.confirmDelete': 'Sind Sie sicher, dass Sie diese Promotion löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'pages.promotions.filter.statusAll': 'Genehmigungsstatus',
  'pages.promotions.filter.statusActive': 'Aktiv',
  'pages.promotions.filter.statusInactive': 'Inaktiv',
  'pages.promotions.filter.clear': 'Zurücksetzen',
  'pages.promotions.empty.title': 'Keine Promotionen gefunden',
  'pages.promotions.empty.hint': 'Klicken Sie oben auf "+ Promotion hinzufügen", um Ihr erstes Angebot zu erstellen.',
  'pages.promotions.card.city': 'Stadt',
  'pages.promotions.card.coupon': 'Gutschein',
  'pages.promotions.card.active': 'Aktiv',
  'pages.promotions.card.inactive': 'Inaktiv',
  'pages.promotions.card.deactivate': 'Deaktivieren',
  'pages.promotions.card.activate': 'Aktivieren',
  'pages.promotions.card.edit': 'Promotion bearbeiten',
  'pages.promotions.card.delete': 'Promotion löschen',
  'pages.promotions.card.defaultBanner': 'GetSettled-Promotion',
  'pages.promotions.card.defaultType': 'Promotion',
  'pages.promotions.card.copyCoupon': 'Gutscheincode kopieren',
  'pages.promotions.status.approved': 'GENEHMIGT',
  'pages.promotions.status.pending': 'AUSSTEHEND',
  'pages.promotions.status.rejected': 'ABGELEHNT',
  'pages.promotions.validation.titleRequired': 'Promotion-Titel ist erforderlich',
  'pages.promotions.validation.titleMinLength': 'Titel muss mindestens 3 Zeichen lang sein',
  'pages.promotions.validation.descriptionRequired': 'Beschreibung ist erforderlich',
  'pages.promotions.validation.cityRequired': 'Stadt ist erforderlich',
  'pages.promotions.validation.typeRequired': 'Promotion-Typ ist erforderlich',
  'pages.promotions.validation.dateRequired': 'Promotion-Datum ist erforderlich',
  'pages.promotions.validation.timeRequired': 'Promotion-Uhrzeit ist erforderlich',
  'pages.promotions.validation.webUrlInvalid': 'Bitte geben Sie eine gültige URL ein (z. B. https://example.com/angebot)',
  'pages.promotions.validation.sharingUrlInvalid': 'Bitte geben Sie eine gültige URL ein (z. B. https://example.com/teilen)',
  'pages.promotions.toast.couponCopied': 'Gutscheincode "{{code}}" in die Zwischenablage kopiert!',
  'pages.promotions.toast.fillRequired': 'Bitte füllen Sie alle Pflichtfelder aus',
  'pages.promotions.toast.updateSuccess': 'Promotion erfolgreich aktualisiert',
  'pages.promotions.toast.createSuccess': 'Promotion erfolgreich erstellt',
  'pages.promotions.toast.activated': 'Promotion aktiviert',
  'pages.promotions.toast.deactivated': 'Promotion deaktiviert',
  'pages.promotions.toast.deleteSuccess': 'Promotion erfolgreich gelöscht',
  'pages.promotions.toast.saveFailed': 'Promotion konnte nicht gespeichert werden',
  'pages.promotions.toast.statusFailed': 'Statusaktualisierung fehlgeschlagen',
  'pages.promotions.toast.deleteFailed': 'Promotion konnte nicht gelöscht werden',
  'pages.promotions.fields.title': 'Promotion-Titel',
  'pages.promotions.fields.description': 'Beschreibung',
  'pages.promotions.fields.details': 'Promotion-Details (optional)',
  'pages.promotions.fields.discountText': 'Rabatt-Text (optional)',
  'pages.promotions.fields.discountCoupon': 'Rabatt-Gutschein (optional)',
  'pages.promotions.fields.couponTitle': 'Gutschein-Titel (optional)',
  'pages.promotions.fields.promotionDate': 'Promotion-Datum (YYYY-MM-DD)',
  'pages.promotions.fields.promotionTime': 'Promotion-Uhrzeit (HH:mm)',
  'pages.promotions.fields.webUrl': 'Web-URL (optional)',
  'pages.promotions.fields.sharingUrl': 'Teilen-URL (optional)',
  'pages.promotions.fields.ownerName': 'Inhaber-Name (optional)',
  'pages.promotions.fields.terms': 'AGB / Bedingungen (optional)',
  'pages.promotions.fields.targetedAudience': 'Zielgruppe (optional)',
  'pages.promotions.fields.whatYouGet': 'Was Sie erhalten',
  'pages.promotions.fields.addItem': 'Element hinzufügen',
  'pages.promotions.fields.add': 'Hinzufügen',
  'pages.promotions.fields.noItems': 'Noch keine Elemente hinzugefügt. Klicken Sie auf "Element hinzufügen".',
  'pages.promotions.fields.active': 'Aktiv',
  'pages.promotions.cta.title': 'Call To Action',
  'pages.promotions.cta.textEn': 'Call To Action (Englisch)',
  'pages.promotions.cta.textDe': 'Call To Action (Deutsch)',
  'pages.promotions.cta.type': 'Call To Action-Typ',
  'pages.promotions.cta.url': 'Call To Action Link / URL',
  'pages.promotions.placeholders.discountText': 'z.B. 20% Rabatt oder 50€ sparen',
  'pages.promotions.placeholders.discountCoupon': 'z.B. SUMMER20',
  'pages.promotions.placeholders.couponTitle': 'z.B. Sommer-Gutschein',
  'pages.promotions.placeholders.webUrl': 'https://example.com/angebot',
  'pages.promotions.placeholders.sharingUrl': 'https://example.com/teilen',
  'pages.promotions.placeholders.targetedAudience': 'z.B. Alle Neukunden in Berlin',
  'pages.promotions.placeholders.cta': 'z.B. Jetzt buchen, Angebot sichern',
  'pages.promotions.placeholders.ctaEn': 'z.B. Book Now, Claim Offer',
  'pages.promotions.placeholders.ctaDe': 'z.B. Jetzt buchen, Angebot sichern',
  'pages.promotions.placeholders.whatYouGetItem': 'Geben Sie ein Element ein (z.B. Kostenlose Beratung, 15% Rabattcode)',
  'pages.promotions.type.discount': 'Rabatt',
  'pages.promotions.type.specialoffer': 'Sonderangebot',
  'pages.promotions.type.event': 'Veranstaltung',
  'pages.promotions.type.banner': 'Banner',
  'pages.promotions.type.voucher': 'Gutschein',
  'pages.promotions.type.general': 'Allgemein',
  'pages.promotions.btn.cancel': 'Abbrechen',
  'pages.promotions.btn.save': 'Änderungen speichern',
  'pages.promotions.btn.create': 'Promotion erstellen',
  'pages.promotions.btn.close': 'Schließen',
  'pages.promotions.btn.delete': 'Löschen',

  // Custom Push Notifications Page (German)
  'pages.customPush.title': 'Custom-Push-Benachrichtigungen',
  'pages.customPush.subtitle': 'Erstellen, verwalten, bearbeiten und verfolgen Sie benutzerdefinierte Push-Benachrichtigungen für Promotionen.',
  'pages.customPush.addNotification': 'Benachrichtigung hinzufügen',
  'pages.customPush.searchPlaceholder': 'Benachrichtigungen nach Titel oder Nachricht suchen...',
  'pages.customPush.status': 'Status',
  'pages.customPush.allStatuses': 'Alle Status',
  'pages.customPush.allCategories': 'Alle Kategorien',
  'pages.customPush.allServices': 'Alle Dienstleistungen',
  'pages.customPush.filterService': 'Dienstleistung',
  'pages.customPush.statusApproved': 'Genehmigt',
  'pages.customPush.statusPending': 'Ausstehend',
  'pages.customPush.statusRejected': 'Abgelehnt',
  'pages.customPush.clearFilters': 'Filter zurücksetzen',
  'pages.customPush.tableHeaderDetails': 'Benachrichtigungsdetails',
  'pages.customPush.tableHeaderCategory': 'Kategorie',
  'pages.customPush.tableHeaderTargetTitle': 'Dienstleistungs-Titel',
  'pages.customPush.tableHeaderNote': 'Hinweis',
  'pages.customPush.tableHeaderDate': 'Erstellungsdatum',
  'pages.customPush.tableHeaderStatus': 'Status',
  'pages.customPush.tableHeaderActions': 'Aktionen',
  'pages.customPush.loading': 'Benachrichtigungen werden geladen...',
  'pages.customPush.noNotificationsTitle': 'Keine Benachrichtigungen gefunden',
  'pages.customPush.noNotificationsSubtitle': 'Versuchen Sie, Ihre Suchanfrage oder den Statusfilter anzupassen.',
  'pages.customPush.tooltipView': 'Benachrichtigungsdetails anzeigen',
  'pages.customPush.tooltipEdit': 'Benachrichtigung bearbeiten',
  'pages.customPush.tooltipEditDisabled': 'Genehmigte Benachrichtigungen können nicht bearbeitet werden',
  'pages.customPush.tooltipDelete': 'Benachrichtigung löschen',
  'pages.customPush.tooltipDeleteDisabled': 'Genehmigte Benachrichtigungen können nicht gelöscht werden',
  'pages.customPush.dialogAddTitle': 'Benachrichtigung hinzufügen',
  'pages.customPush.dialogEditTitle': 'Benachrichtigung bearbeiten',
  'pages.customPush.dialogAddSubtitle': 'Verfassen und senden Sie eine Push-Benachrichtigung an Ihre Nutzer',
  'pages.customPush.dialogEditSubtitle': 'Details vor der Übertragung ändern',
  'pages.customPush.fieldCategory': 'Kategorie der Benachrichtigung',
  'pages.customPush.categoryContact': 'Dienstleistung',
  'pages.customPush.categoryPromotion': 'Promotion',
  'pages.customPush.categoryCustom': 'Benutzerdefiniert (Ohne Verknüpfung)',
  'pages.customPush.fieldContact': 'Dienstleistung auswählen',
  'pages.customPush.fieldContactPlaceholder': 'Wählen Sie eine Dienstleistung...',
  'pages.customPush.fieldPromotion': 'Promotion auswählen',
  'pages.customPush.fieldPromotionPlaceholder': 'Wählen Sie eine Promotion...',
  'pages.customPush.fieldEvent': 'Veranstaltung auswählen',
  'pages.customPush.fieldEventPlaceholder': 'Wählen Sie eine Veranstaltung...',
  'pages.customPush.fieldTitle': 'Titel der Benachrichtigung',
  'pages.customPush.fieldTitlePlaceholder': 'z. B. 🎉 Spezielles Wochenend-Angebot 20% Rabatt',
  'pages.customPush.fieldMessage': 'Nachricht der Benachrichtigung',
  'pages.customPush.fieldMessagePlaceholder': 'Beschreibung der Benachrichtigungsnachricht eingeben...',
  'pages.customPush.btnCancel': 'Abbrechen',
  'pages.customPush.btnSaving': 'Wird gespeichert...',
  'pages.customPush.btnUpdate': 'Benachrichtigung aktualisieren',
  'pages.customPush.btnSend': 'Benachrichtigung senden',
  'pages.customPush.deleteConfirmTitle': 'Löschen bestätigen',
  'pages.customPush.deleteConfirmMessage': 'Möchten Sie die Benachrichtigung "{{title}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'pages.customPush.btnDelete': 'Löschen',
  'pages.customPush.viewDetailsTitle': 'Benachrichtigungsdetails',
  'pages.customPush.viewDetailsLoading': 'Benachrichtigungsdetails werden abgerufen...',
  'pages.customPush.viewFieldTitle': 'Titel',
  'pages.customPush.viewFieldCategory': 'Kategorie',
  'pages.customPush.viewFieldTargetTitle': 'Dienstleistungs-Titel',
  'pages.customPush.viewFieldContact': 'Dienstleistung',
  'pages.customPush.viewFieldPromotion': 'Promotion',
  'pages.customPush.viewFieldEvent': 'Veranstaltung',
  'pages.customPush.viewFieldMessage': 'Nachrichteninhalt',
  'pages.customPush.viewFieldAdminNote': 'Admin-Hinweis',
  'pages.customPush.viewFieldDateCreated': 'Erstellungsdatum',
  'pages.customPush.viewFieldProviderName': 'Anbietername',
  'pages.customPush.viewFieldProviderEmail': 'Anbieter-E-Mail',
  'pages.customPush.btnClose': 'Schließen',
  'pages.customPush.toastSelectContact': 'Bitte wählen Sie eine Dienstleistung aus.',
  'pages.customPush.toastSelectPromotion': 'Bitte wählen Sie eine Promotion aus.',
  'pages.customPush.toastSelectEvent': 'Bitte wählen Sie eine Veranstaltung aus.',
  'pages.customPush.toastEnterTitle': 'Bitte geben Sie einen Benachrichtigungstitel ein.',
  'pages.customPush.toastEnterMessage': 'Bitte geben Sie den Benachrichtigungstext ein.',
  'pages.customPush.toastApprovedCannotEdit': 'Genehmigte Benachrichtigungen können nicht bearbeitet werden.',
  'pages.customPush.toastApprovedCannotDelete': 'Genehmigte Benachrichtigungen können nicht gelöscht werden.',
  'pages.customPush.toastUpdatedSuccess': 'Benachrichtigung erfolgreich aktualisiert!',
  'pages.customPush.toastCreatedSuccess': 'Benachrichtigung erfolgreich erstellt und gesendet!',
  'pages.customPush.toastSaveFailed': 'Speichern der Benachrichtigung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'pages.customPush.toastDeletedSuccess': 'Benachrichtigung erfolgreich gelöscht.',
  'pages.customPush.toastDeleteFailed': 'Löschen der Benachrichtigung fehlgeschlagen.',
  'pages.customPush.tabGeneric': 'Generische Benachrichtigung',
  'pages.customPush.tabCustom': 'Benutzerdefinierte Benachrichtigung',
  'pages.customPush.sendCustomNotification': 'Benutzerdefinierte Benachrichtigung senden',
  'pages.customPush.dialogCustomTitle': 'Benutzerdefinierte Push-Benachrichtigung senden',
  'pages.customPush.dialogCustomSubtitle': 'Gezielte Push-Benachrichtigung basierend auf Dienstleistung und Interaktionszeitraum senden',
  'pages.customPush.fieldModule': 'Modul',
  'pages.customPush.fieldLookbackDays': 'Rückblickzeitraum (Tage)',
  'pages.customPush.fieldLookbackDaysPlaceholder': 'Rückblick-Tage eingeben (z. B. 30)',
  'pages.customPush.fieldLookbackDaysHelp': 'Zielgruppe: Aktive Kunden, die in den letzten X Tagen mit dieser Dienstleistung interagiert haben.',
  'pages.customPush.tableHeaderModule': 'Modul',
  'pages.customPush.tableHeaderEntity': 'Ziel-Dienstleistung',
  'pages.customPush.tableHeaderLookback': 'Rückblick',
  'pages.customPush.tableHeaderRecipients': 'Empfänger',
  'pages.customPush.viewFieldModule': 'Modul',
  'pages.customPush.viewFieldLookbackDays': 'Rückblickzeitraum',
  'pages.customPush.viewFieldRecipients': 'Berechtigte Empfänger gesamt',
  'pages.customPush.viewFieldSuccessCount': 'Erfolgreich zugestellt',
  'pages.customPush.viewFieldFailureCount': 'Fehlgeschlagene Zustellungen',
  'pages.customPush.toastCustomSentSuccess': 'Benutzerdefinierte Push-Benachrichtigung erfolgreich gesendet!',
  'pages.customPush.toastCustomSendFailed': 'Benutzerdefinierte Benachrichtigung konnte nicht gesendet werden.',
  'pages.customPush.historyEmptyTitle': 'Noch keine benutzerdefinierten Benachrichtigungen gesendet',
  'pages.customPush.historyEmptySubtitle': 'Klicken Sie auf „Benutzerdefinierte Benachrichtigung senden“, um gezielte Benachrichtigungen an Kunden zu senden.',
  'pages.customPush.loadingHistory': 'Verlauf wird geladen...',
  'pages.customPush.statusSent': 'Gesendet',
};
